var path = 'app/scripts/modules/openstack/src/common/cacheRefresh.tooltip.html';
var html = "<p ng-if=\"cache.loading\">{{refreshToolTipLabel}} list is <strong>refreshing</strong>.</p>\n<p ng-if=\"!cache.loading\">Click <span class=\"fa fa-refresh\"></span> to refresh {{refreshToolTipLabel}} list.</p>\n<p>Last Updated:<br>{{cache.lastRefresh | timestamp }}<br>({{cache.lastRefresh | relativeTime }})</p>\n<p class='small'><strong>Note:</strong> Due to caching, data may be delayed up to 2 minutes</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/common/cacheRefresh.tooltip.html
// module id = 1391
// module chunks = 0